import React from "react";
import { Box, Heading, Text, SimpleGrid, Button, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import consultingBg from "../assets/ccs.jpg"; 

export default function ServicesAdvisory() {
  const MotionBox = motion(Box);

  const processSteps = [
    {
      title: "Design & Drawings Approval",
      description:
        "Our team reviews solar project designs to confirm they meet all applicable codes, regulations, and industry benchmarks, ensuring optimal system performance and long-term sustainability.",
    },
    {
      title: "Construction & Quality Audits",
      description:
        "On-site audits to ensure EPC contractors are following approved designs, quality standards, safety protocols, and timelines.",
    },
  ];

  return (
    <Box>
      <Box bg="#F5FAF6" color="#305D24">
        {/* Hero Section */}
        <Box
          position="relative"
          shadow="xl"
          mb={10}
          textAlign="center"
          overflow="hidden"
           minH={{ base: "300px", md: "350px" }}
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgImage={`url(${consultingBg})`}
            bgSize="cover"
            bgPosition="center"
            filter="brightness(0.6) blur(2px)"
            zIndex={0}
          />
          <Box
            position="relative"
            zIndex={1}
            color="white"
            p={{ base: 10, md: 16 }}
          >
            <Heading
              fontSize={{ base: "3xl", md: "5xl" }}
              mb={4}
              textShadow="2px 2px 4px rgba(0,0,0,0.7)"
            >
              Consulting & Compliance Services
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              mt={4}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              End-to-end consulting and compliance support for renewable energy
              projects.
            </Text>
            <Text
              mt={2}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              We help clients make informed decisions, meet regulatory
              requirements, and ensure projects are technically and commercially
              sound.
            </Text>
          </Box>
        </Box>

        {/* Process Section */}
        <Box
          bg="#F5FAF6"
          rounded="2xl"
          p={{ base: 6, md: 12 }}
          mb={10}
          mx={{ base: 4, md: 20 }}
          textAlign="center"
        >
          <Heading
            size="xl"
            mb={10}
            fontSize={{ base: "2xl", md: "5xl" }}
            color="#305D24"
          >
            Our Process
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
            {processSteps.map((step, i) => (
              <MotionBox
                key={i}
                p={6}
                bg="white"
                rounded="xl"
                shadow="md"
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
              >
                <Heading size="md" mb={3} color="#519C36">
                  {step.title}
                </Heading>
                <Text fontSize="sm" color="gray.700">
                  {step.description}
                </Text>
              </MotionBox>
            ))}
          </SimpleGrid>
        </Box>

        {/* Call to Action */}
        <Flex justify="center" py={10}>
          <Button
            bg="#FBBF24"
            color="#065F46"
            size="lg"
            as="a"
            href="/contact"
            _hover={{ bg: "#F59E0B", transform: "scale(1.05)" }}
          >
            Start a Project
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
